//=====================================================================
// Tabs JS
//=====================================================================
// If the tab buttons are in cloned items such as a slider, then...
// data-target="tab1" with unique ID must be added to the button, and
// id="tab1" with matching id to the button

function tabsJS() {
    // Clean up existing event listeners
    document.removeEventListener('dynamicContentLoaded', tabsJS);

    const tabGroup = document.querySelectorAll('[data-tabGroup]');

    if (!tabGroup) return;

    tabGroup.forEach((group, index) => {
        const tabButtons = group.querySelector('[data-tabButtons]');

        if (tabButtons === null) return;

        // Remove existing click handler if present
        const oldHandler = tabButtons._clickHandler;
        if (oldHandler) {
            tabButtons.removeEventListener('click', oldHandler);
        }

        const tabButton = Array.from(tabButtons.querySelectorAll('[data-tabButton]'));
        const tabContent = Array.from(group.querySelectorAll('[data-tabContent]'));

        // Add aria attributes to buttons and content
        tabButton.forEach((button, i) => {
            if (button.hasAttribute('data-target')) return;

            const uniqueId = `tabGroup${index}button${i}`;
            button.id = uniqueId;
            button.setAttribute('data-target', uniqueId);

            if (tabContent[i]) {
                tabContent[i].setAttribute('aria-labelledby', uniqueId);
                tabContent[i].setAttribute('data-target', uniqueId);
            }
        });


        // Button Events
        const clickHandler = (event) => {
  
                const target = event.target;
                if (!target.matches('[data-tabButton]') || target.matches('[aria-expanded="true"]')) return;

                const buttonId = target.getAttribute('data-target');

                tabButton.forEach(button => {
                    button.setAttribute('aria-expanded', target === button ? 'true' : 'false');
                });

            tabContent.forEach(content => {
                const isVisible = content.getAttribute('aria-labelledby') === buttonId || content.id === buttonId;
                content.setAttribute('aria-hidden', !isVisible); // Set aria-hidden based on visibility
            });
        };

        // Store handler reference for future cleanup
        tabButtons._clickHandler = clickHandler;
        tabButtons.addEventListener('click', clickHandler);

    });


    // Add single event listener for dynamic content
    document.addEventListener('dynamicContentLoaded', tabsJS);
}

// Self-invoke the function
tabsJS();

// Export the function for potential use in other files
export { tabsJS };